import type { MetaFunction } from 'react-router'
import { STATIC_PAGE_HEADERS } from "~/lib/cache.server"
import { Navbar } from '~/components/navbar'
import { Footer } from '~/components/footer'

export function headers() { return STATIC_PAGE_HEADERS }

export const meta: MetaFunction = () => [
  { title: 'Mentions légales — AfficheServices' },
  { name: 'description', content: 'Mentions légales du site AfficheServices.fr.' },
  { tagName: 'link', rel: 'canonical', href: 'https://www.afficheservices.fr/mentions-legales' },
]

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="mx-auto max-w-3xl px-4 py-16 lg:px-6">
        <h1 className="text-3xl font-bold text-slate-900">Mentions légales</h1>
        <p className="mt-3 text-sm text-slate-600 leading-relaxed">
          Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance
          dans l'économie numérique, il est précisé aux utilisateurs du site afficheservices.fr
          l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi.
        </p>

        {/* Éditeur du site */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">Éditeur du site</h2>
          <div className="mt-3 text-sm text-slate-600 leading-relaxed space-y-1">
            <p>Le site afficheservices.fr est édité par :</p>
            <p className="mt-3"><strong className="text-slate-900">AfficheServices SAS</strong></p>
            <p>Société par actions simplifiée au capital de 10 000 euros</p>
            <p>Siège social : Paris, France</p>
            <p>Immatriculée au Registre du Commerce et des Sociétés de Paris</p>
            <p>Numéro RCS : {process.env.COMPANY_RCS ?? 'En cours d\'immatriculation'}</p>
            <p>Numéro de TVA intracommunautaire : {process.env.COMPANY_TVA ?? 'En cours d\'attribution'}</p>
            <p>Directeur de la publication : {process.env.COMPANY_DIRECTOR ?? 'Alex Seo'}</p>
            <p>Email : contact@afficheservices.fr</p>
          </div>
        </div>

        {/* Hébergeur */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">Hébergeur</h2>
          <div className="mt-3 text-sm text-slate-600 leading-relaxed space-y-1">
            <p>Le site est hébergé par :</p>
            <p className="mt-3"><strong className="text-slate-900">Hetzner Online GmbH</strong></p>
            <p>Industriestr. 25</p>
            <p>91710 Gunzenhausen, Allemagne</p>
            <p>Téléphone : +49 (0)9831 505-0</p>
            <p>Site web : www.hetzner.com</p>
          </div>
        </div>

        {/* Propriété intellectuelle */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">Propriété intellectuelle</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            L'ensemble du contenu du site afficheservices.fr (textes, images, graphismes, logo,
            icônes, sons, logiciels, etc.) est protégé par les lois françaises et internationales
            relatives à la propriété intellectuelle. Toute reproduction, représentation,
            modification, publication, transmission, ou dénaturation, totale ou partielle, du site
            ou de son contenu, par quelque procédé que ce soit, et sur quelque support que ce soit,
            est interdite sans l'autorisation écrite préalable d'AfficheServices SAS.
          </p>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Toute exploitation non autorisée du site ou de son contenu, des informations qui y sont
            divulguées, engagerait la responsabilité de l'utilisateur et constituerait une
            contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la Propriété
            Intellectuelle.
          </p>
        </div>

        {/* Limitation de responsabilité */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">Limitation de responsabilité</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            AfficheServices SAS s'efforce de fournir des informations aussi précises que possible
            sur le site afficheservices.fr. Toutefois, elle ne pourra être tenue responsable des
            omissions, des inexactitudes et des carences dans la mise à jour, qu'elles soient de son
            fait ou du fait des tiers partenaires qui lui fournissent ces informations.
          </p>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            AfficheServices SAS agit en tant qu'intermédiaire de mise en relation entre particuliers
            et professionnels du bâtiment. À ce titre, elle ne saurait être tenue responsable de la
            qualité des prestations réalisées par les professionnels inscrits sur la plateforme, ni
            des litiges pouvant survenir entre les utilisateurs et les professionnels.
          </p>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Les liens hypertextes mis en place dans le cadre du site en direction d'autres ressources
            présentes sur le réseau Internet ne sauraient engager la responsabilité
            d'AfficheServices SAS.
          </p>
        </div>

        {/* Droit applicable */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">Droit applicable</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Les présentes mentions légales sont régies par le droit français. En cas de litige, et
            après tentative de résolution amiable, les tribunaux français seront seuls compétents
            pour connaître de ce litige. Le site afficheservices.fr est soumis au droit français et
            les juridictions françaises sont seules compétentes.
          </p>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter
            à l'adresse suivante : contact@afficheservices.fr
          </p>
        </div>
      </div>

      <Footer />
    </div>
  )
}
